<div layout="row" layout-align="start center" class="full-height layout-row layout-align-start-center">

  <div class="layout-row layout-align-start-center text-ellipsis"
       *ngFor="let group of viewGroups; let last = last"
       [ngClass]="{'margin-right-5': !last}">
    <span class="group br-caption-2 font-weight-600"
          [ngStyle]="{'color': group.displayColor, 'border-color': group.displayColor, 'background-color': groupRGBAColorMap[group.id]}">
          {{group.name}}
    </span>
  </div>

  <div class="margin-left-5" *ngIf="!!extraGroups?.length" [ngbTooltip]="tooltipTmpl" openDelay="300" triggers="hover">
    <span class="br-caption-2">{{extraGroupsCount}}</span>
  </div>

</div>


<ng-template #tooltipTmpl>
  <div class="layout-column">
    <span *ngFor="let group of extraGroups">
      {{group.name}}
    </span>
  </div>
</ng-template>
